<template>
  <button type="button" class="btn-destroy-processing">
    <i class="fa-solid fa-sync fa-spin mt-1" />
    <span class="space-icon" />{{ label }}
  </button>
</template>

<script>
export default {
  name: "DestroyButtonProcessing",
  props: ["label"],
};
</script>